<script lang="ts" setup>
import { defineAsyncComponent, shallowRef } from 'vue';
import { useRouter } from 'vue-router';

import { modalService } from '@exchange/libs/modals/src';
import { getNextPathUponLogin } from '@exchange/routing';

const ErrorModal = defineAsyncComponent(() => import('@exchange/libs/modals/src/lib/common/ErrorModal.vue'));

const router = useRouter();

const showErrorModal = (error) => {
  if (!error) {
    return;
  }

  modalService.show(
    shallowRef(ErrorModal),
    {
      messageKey: 'modules.errors.loginFailed',
    },
    {
      'x-error-close': () => {
        modalService.clear();
      },
    },
  );
};

const processLogin = async () => {
  try {
    const next = await getNextPathUponLogin();

    return await router.replace(next);
  } catch (e) {
    return router.replace('/').then(() => showErrorModal(e));
  }
};

processLogin();
</script>

<template>
  <div class="auth-callback-container">
    <div class="auth-callback-container__message">{{ $t('modules.login.loggingYouInMessage') }}</div>
    <ot-spinner class="auth-callback-container__spinner" />
  </div>
</template>

<style lang="scss">
.auth-callback-container {
  z-index: var(--content-z-index);
  display: flex;
  max-width: 100%;
  height: 100%;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgb(var(--v-theme-text-primary));
  font-size: var(--font-size-md);
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &__spinner {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>
